import { useEffect, useState } from 'react';
import useAuth from 'src/hooks/useAuth';
import { CHAMADOS_CONFIG_DESIGN } from './ChamadosConfig.design';
import CaixasEntradaTab from './CaixasEntradaTab';
import { actionListaCaixasEntrada } from 'src/actions/chamados/actionChamadosConfig';
import Iconify from 'src/components/Iconify';

export default function ChamadosConfigComponent() {
  const { user } = useAuth();
  const [listaCaixas, setListaCaixas] = useState([]);

  async function buscarCaixas() {
    try {
      const response = await actionListaCaixasEntrada(`?cliente_id=${user.clienteId}`);
      setListaCaixas(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    buscarCaixas();
  }, []);

  return (
    <div className={CHAMADOS_CONFIG_DESIGN.page.container}>
      {/* Header */}
      <div className={CHAMADOS_CONFIG_DESIGN.page.header.container}>
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-violet-100 flex items-center justify-center">
            <Iconify icon="eva:clipboard-outline" width={28} className="text-violet-600" />
          </div>
          <div>
            <h1 className={CHAMADOS_CONFIG_DESIGN.page.header.title}>Chamados</h1>
            <p className={CHAMADOS_CONFIG_DESIGN.page.header.subtitle}>
              Gerencie as caixas de entrada dos seus chamados. Status e prioridades são configurados dentro de cada caixa.
            </p>
          </div>
        </div>
      </div>

      <CaixasEntradaTab
        listaCaixas={listaCaixas}
        onRefresh={buscarCaixas}
        clienteId={user.clienteId}
      />
    </div>
  );
}
